import React from 'react';
import { FlameIcon, UsersIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
export function UrgencyBanner() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(24);
  return <section className="w-full border-y-[3px] border-dashed border-amber bg-danger px-6 py-12 text-center text-white sm:px-10" data-id="element-182" data-mp="2nhn8pwqdu5al">
      <div className="mx-auto max-w-2xl" data-id="element-183" data-mp="2sapsjd5cy0dl">
        <p className="flex items-center justify-center gap-2 text-xl font-bold sm:text-2xl" data-id="element-184" data-mp="2wb8l59f2ragu">
          <FlameIcon className="h-6 w-6" aria-hidden="true" data-id="element-185" data-mp="319tc0i8fshsm" /> ¡Oferta por 24 horas solamente!
        </p>
        <p className="mt-4 text-xl font-bold text-amber sm:text-2xl" data-id="element-186" data-mp="369frkybqma4l">
          Antes: <span className="line-through" data-id="element-187" data-mp="367boujpkrh5w">€45</span> | Ahora: €17,99 (60% descuento)
        </p>

        <div className="mt-7 flex items-center justify-center gap-3 font-mono text-3xl font-bold sm:text-4xl" role="timer" aria-live="off" data-id="element-188" data-mp="3b5wpgk8qo2uv">
          <div className="rounded-lg bg-white/10 px-4 py-2" data-id="element-189" data-mp="1gtgb0w5shiex">{hours}</div>
          <span aria-hidden="true" data-id="element-190" data-mp="27eq0rswtngoc">:</span>
          <div className="rounded-lg bg-white/10 px-4 py-2" data-id="element-191" data-mp="27fhxj725nkg7">{minutes}</div>
          <span aria-hidden="true" data-id="element-192" data-mp="22nhq6tjr9p9l">:</span>
          <div className="rounded-lg bg-white/10 px-4 py-2" data-id="element-193" data-mp="22mos0gyv4832">{seconds}</div>
        </div>
        <p className="mt-2 text-xs uppercase tracking-wide text-white/80" data-id="element-194" data-mp="1xpg8aby2fvzp">Horas : Minutos : Segundos</p>

        <p className="mt-6 flex items-center justify-center gap-2 text-sm" data-id="element-195" data-mp="1sreqrvgag4qc">
          <span className="relative flex h-2 w-2" data-id="element-196" data-mp="2qcj5n0r0a0od">
            <span className="absolute inline-flex h-full w-full animate-pulse-dot rounded-full bg-amber" data-id="element-197" data-mp="2qb80awhwwkv5" />
          </span>
          <UsersIcon className="h-4 w-4" aria-hidden="true" data-id="element-198" data-mp="2gev86320mf2i" /> 47 personas mirando esto ahora
        </p>

        <a href="#comprar" className="mt-7 inline-flex w-full items-center justify-center rounded-lg bg-amber px-8 py-5 text-lg font-bold text-danger transition-colors duration-150 ease-out hover:bg-amber-dark hover:text-white sm:w-auto sm:min-w-[420px]" data-id="element-199" data-mp="2ceces4kh50y7">
          Quiero acceso ahora — 17,99€
        </a>
      </div>
    </section>;
}